module.exports = __webpack_public_path__ + "img/Detail_thumbnail.fe042e32.webp";